module.exports = __webpack_public_path__ + "img/Jump Screenshoot (0-00-09-06)_16.a10e1dc2.jpg";